/* Fusion des réponses du questionnaire descriptif dans le champ témoignages.

   Le champ est stocké en texte (une question par bloc, ses réponses en puces).
   On le reparse avant chaque import pour fusionner par question et écarter les
   réponses déjà présentes : réimporter le même export ne duplique plus rien,
   et un export partiel enrichit l'existant au lieu de l'empiler. */

export function parseTemoignages(text) {
  const blocks = new Map();
  if (!text) return blocks;

  for (const block of text.split(/\n{2,}/)) {
    const lines = block.split('\n').filter((l) => l.trim());
    if (lines.length === 0) continue;
    const question = lines[0].trim();
    const answers = lines.slice(1)
      .filter((l) => l.trimStart().startsWith('- '))
      .map((l) => l.trimStart().slice(2).trim())
      .filter(Boolean);
    if (!blocks.has(question)) blocks.set(question, []);
    const bucket = blocks.get(question);
    for (const a of answers) if (!bucket.includes(a)) bucket.push(a);
  }
  return blocks;
}

export function serializeTemoignages(blocks) {
  return [...blocks.entries()]
    .filter(([, answers]) => answers.length)
    .map(([question, answers]) => `${question}\n- ${answers.join('\n- ')}`)
    .join('\n\n');
}

/* Fusionne les questions/réponses agrégées d'un import dans le texte existant.
   Renvoie le texte fusionné et le nombre de réponses réellement ajoutées. */
export function mergeTemoignages(existingText, incoming) {
  const blocks = parseTemoignages(existingText);
  let added = 0;

  for (const { q, answers } of incoming) {
    const question = q.trim();
    if (!blocks.has(question)) blocks.set(question, []);
    const bucket = blocks.get(question);
    for (const answer of answers) {
      const clean = answer.trim();
      if (clean && !bucket.includes(clean)) {
        bucket.push(clean);
        added += 1;
      }
    }
  }

  return { text: serializeTemoignages(blocks), added };
}
